import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box
} from '@mui/material';
import { splitPassage } from './passageFormat';

const PassageDialog = ({ open, handleClose, passage, caseStudyOption }) => {
  const trimmedPassage = passage?.trim();

  const renderContent = () => {
    if (caseStudyOption === 'generateImage' && trimmedPassage) {
      return (
        <Box display="flex" justifyContent="center" alignItems="center" mt={2}>
          <img
            src={`data:image/png;base64,${trimmedPassage}`}
            alt="Generated Visual"
            style={{ maxWidth: '100%', maxHeight: '400px', borderRadius: 8 }}
          />
        </Box>
      );
    }
    // Generated passages lead with their title on the first line — show it in bold,
    // set apart from the body, and matching how the draft preview renders it.
    const { title, body } = splitPassage(trimmedPassage);
    return (
      <>
        {title && (
          <Typography variant="subtitle1" sx={{ fontWeight: 700, mb: 2 }}>
            {title}
          </Typography>
        )}
        <Typography variant="body1" sx={{ whiteSpace: 'pre-wrap', lineHeight: 1.6 }}>
          {body}
        </Typography>
      </>
    );
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      fullWidth
      maxWidth="sm"
    >
      <DialogTitle>
        {caseStudyOption === 'generateImage' ? 'Case Study Image' : 'Case Study Passage'}
      </DialogTitle>
      <DialogContent dividers sx={{ padding: 3 }}>
        {renderContent()}
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Button onClick={handleClose} variant="contained" color="secondary">
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default PassageDialog;
